import { X } from "lucide-react"

interface ErrorToastProps {
  title: string
  subtitle?: string
}

/** Dark card with a peach glow + X badge, used for error notifications. */
export function ErrorToast({ title, subtitle }: ErrorToastProps) {
  return (
    <div
      data-slot="error-toast"
      className="flex items-center gap-3 rounded-[16px] border-2 border-peach bg-dark-surface p-3 drop-shadow-[0_0_10px_rgba(255,83,127,0.6)]"
    >
      <span className="flex size-12 shrink-0 items-center justify-center rounded-full bg-peach/20">
        <X className="size-6 text-peach" strokeWidth={2.5} />
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="text-base font-semibold text-peach">{title}</p>
        {subtitle && <p className="line-clamp-2 text-xs text-purple-light/70">{subtitle}</p>}
      </div>
    </div>
  )
}
